import src from "IMAGE";
export default { src, width: 245, height: 39, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AFZWVv9UVFT/UVFR/0BAQP86Ojr/P11f/0V2R/9cZjf/9IcPTo04RlMAAAAASUVORK5CYII="};
